import * as React from 'react';
import { storyblokEditable, StoryblokComponent } from '@storyblok/react';
import type { SbBlokData } from '@storyblok/react';

import type { FooterColumnStoryblok } from '../../types/storyblok';

interface FooterColumnProps {
  blok: FooterColumnStoryblok;
}

export const FooterColumn: React.FC<FooterColumnProps> = ({ blok }) => {
  if (!blok.links || blok.links.length === 0) return null;

  return (
    <div {...storyblokEditable(blok as unknown as SbBlokData)} className="flex flex-col gap-7">
      <h2 className="text-body2 font-bold text-neutral-white">{blok.title}</h2>
      <ul className="flex flex-col gap-4">
        {blok.links.map((link) => (
          <StoryblokComponent key={link._uid} blok={link as unknown as SbBlokData} />
        ))}
      </ul>
    </div>
  );
};
